// extracted by mini-css-extract-plugin
export default {"navbarLogo":"NavbarLogo_navbarLogo__h2Dtz","expanded":"NavbarLogo_expanded__HSYAI"};